module.exports = __webpack_public_path__ + "img/07.1586176d.png";